import {PortChunk} from "../../chunks/types/PortChunk";

export function getDirectionFromPortChunk(
  portChunk: PortChunk
): string {
  const {
    captures: {
      1: portDirectionChunk
    }
  } = portChunk;
  return portDirectionChunk.captures[0];
}
